import React, { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { ContactInquiry } from "./contact-inquiry";
import { ContactFaq } from "./contact-faq";
export interface Props {setData : Function}
export const Contact:React.FC<Props> = ({setData}) => {
    const location = useLocation()
    const path = location.pathname.split('/')
    useLayoutEffect(()=>{
        switch(path[2]){
            case 'inquiry' : setData((prev:any)=>({...prev, title_2_kr : '문의하기', title_2_en : 'Contact Us', className_2 : 'contactUs'})); break;
            case 'faq' : setData((prev:any)=>({...prev, title_2_kr : 'FAQ', title_2_en : 'FAQ', className_2 : 'faq'})); break;
        }
    },[location])
    return(
        <>
        {path[2] === 'inquiry' ? <ContactInquiry/> : ""}
        {path[2] === 'faq' ? <ContactFaq/> : ''}
        </>
    )
}